<div *ngIf="objIframe" class="d-flex w-100 justify-content-center">
    <iframe #iframe [id]="'Iframe'+block.id" [width]="objIframe.width" [height]="objIframe.height"
        [src]="objIframe.src | safe" frameborder="0" [class]="objIframe.class" [allow]="objIframe.allow"
        allowfullscreen>
    </iframe>
</div>